import { http } from '@/core/helpers/axiosHelper';

export default class CountryService {
   async get(search_term: String) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/country', {
            params: {
               'filter[name]': search_term,
            },
         })
         .then((response) => response.data);
   }
}
